export const endpoint = {
    // BASE_URL_STAGING: "http://192.168.1.15:8080/api/",
    // BASE_URL_STAGING:"http://20.185.63.192:8080/api/",
    BASE_URL_STAGING: "https://api.itengo.pro/api/",

    SIGN_UP: "public/auth/sign-up",
    SIGN_UP_OTP_VERIFY: "public/auth/verify-otp",
    FETCH_IMAGE_API:"public/fetch-config",
    SIGN_IN: "public/auth/login",
    FORGET_PASSWORD: 'public/auth/forget-password',
    RESET_PASSWORD: "public/auth/reset",
    GENERATE_OTP: "api/employee/otp",
    CREATE_NEW_PASSWORD: "api/employee/otp-verify",
    USER_DETAIL: "",
    REFRESH_TOKEN: "",
    GOOGLE_SIGN_UP : 'https://api.itengo.pro/oauth2/authorization/google',
    FETCH_CONFIG : "public/fetch-config",
    FETCH_PERMISSION :"protected/profile/fetch-permission",
    MINOR_ACCOUNT_LIST :"protected/v2/minors",
    MINOR_PERMISSION :"protected/game/permission",
    OUTH_SIGN_UP: 'public/auth/oauth-sign-up',
    GOOGLE_REGISTER: "public/oauth/google/android",
    FETCH_MINOR_PERMISSION :"protected/profile/fetch-permission-by-minor",
    OAUTH_CALLBACK:'login/oauth2/code/google',
    LOG_OUT: 'protected/auth/logout',


    // GAME API END POINT
    FETCH_EXPLORE_DATA: "protected/game/visible-games",
    FETCH_GAME_DATA: "protected/game/all-games?page=0&size=10",
    FILTER_GAME_DATA: 'protected/game/filter',
    CREATE_GAMES: 'protected/game/create-or-update',
    GAME_DETAIL: 'protected/game/game-by-id',
    JOINED_GAME: 'protected/game/joined-games',
    HOSTED_GAME: 'protected/game/hosted-games',
    LEAVE_GAME: 'protected/game/leave-game',
    INVITE_GAME : 'protected/profile/filter-users',
    USER_SEARCH_FILTER: 'protected/profile/create-user-filter',
    FETCH_SPORTS: 'protected/game/all-games?page=0&size=10',
    FECH_SPORTS_DETAIL_CONFIG : 'protected/sport/fetch',
    FETCH_GAME_FILTER_DATA:"protected/game/fetch-filter",

    // FETCH_COURT: 'protected/user/court/fetch',
    FETCH_COURT: 'protected/user/nearby-courts',
    FETCH_MAP_COURT: 'protected/user/mapview-courts',
    CHOOSE_SPORT: 'protected/sport/fetch',
    DELETE_EXCLUSION_LIST: 'protected/profile/delete-user-exclusion-list',
    DELETE_INCLUTION_LIST: 'protected/profile/delete-user-preferrable-list',
    REMOVE_FILTER_GAME:'protected/game/remove-filter',
    FETCH_FEEDBACK:  'public/fetch-feedbacks',


    // PROFILE END POINT
    PLAYER_PROFILE: "protected/profile/fetch-by-id",
    EDIT_PROFILE: "protected/profile/create-or-update",
    CREATE_TENNIS_PROFILE: 'protected/profile/create-update-sport-profile',
    PLAYER_FAVROUTE_LIST: 'protected/profile/fetch-inclusion-list',
    PLAYER_ENCLUSTION_LIST: 'protected/profile/fetch-excluded-list',
    FETCH_MY_SLEF_PROFILE_PLAYER:'protected/profile/fetch',
   

    MOVE_IN_PREFERABLE_LIST: 'protected/profile/include-user',
    MOVE_INTO_EXCLUSION_LIST: "protected/profile/exclude-user",
    SPORT_FETCH: 'protected/sport/fetch',
    GET_INVITE_PLAYER: '',
    GET_INVITE_INCLUSION_LIST: 'protected/profile/unpreferred-users',
    GET_INVITE_EXCLUSION_LIST: 'protected/profile/unexcluded-users',
    DELETE_ACCOUNT: 'protected/v2/deactivate',
    CANCEL_USER_FILTER:'protected/profile/remove-user-filter',

    //Stringer
    fetchAllStringerPlayer: "protected/profile/filter-users",
    fetchAllStringerPlayer: 'protected/profile/fetch-stringer',
    EXCLUDE_USER: 'protected/profile/exclude-user',
    FAVOURITE_USER: '',
    STRINGER_PROFILE: 'protected/profile/fetch',
    INVITATION_GAME: 'protected/game/game-invitation',
    STRINGER_PROFILE_DETAIL: 'protected/profile/fetch-by-id',
    STRINGER_OR_NOT: 'protected/profile/stringer',

    // Find Player
    FETCH_PROFILE_FILTER_DATA : 'protected/profile/user-filters',


    //  SUBSCRIPTION PLAN
    SUBSCRIPTION_PLAN: "protected/user/plans",
    SUBSCRIPTION_PAYMENT_API: "protected/transaction/subscription",
    CANCEL_SUBSCRIPTION :'protected/transaction/cancel-subscription',
    FETCH_DETAIL_FOR_OT_API :"protected/user/fetch-configurations",
    SELECT_PLAN: "protected/user/select-plan",


    // PROFILE PAYMENT 
    ANOTHER_PAYMENT_API: "protected/transaction/setup-intent",
    MEMBERSHIP_DETAIL:"protected/profile/subscription-details",

    PAYMENT_CREATE_ONE_TIME_API : "protected/transaction/create-game-payment",
    SAVE_CARD_DETAIL_API:"protected/transaction/saved-cards",
    PAYMENT_JOIN_ONE_TIME_API :"protected/transaction/join-game-payment",
    PAYMENT_NOTIFICATION_ONE_TIME_API:'protected/game/invite-response?action=true',


    //NOTIFICATION 
    NOTIFICATION_PENDING: 'protected/notifications/pending',
    MARK_SEEN: 'protected/notifications/mark-seen',
  
    GAME_INVITATION: 'protected/game/invite-response',
    FETCH_INVITATION: 'protected/game/fetch-invitation',
    ACCEPTED_REJECTED: '',
     FETCH_REQUESTED_LIST:"protected/game/fetch-request",
     HOST_RESPONSE : "protected/game/host-response",


    //Game 
    GAME_REQUESTED_TO_JOIN: '/protected/game/join-game',
    STARTED_GAME: 'protected/game/start-game',
    COMPLETED_GAME: "protected/game/complete-game",
    // protected/game/cancel-game?gameId=12
    CANCEL_GAME: "protected/game/cancel-game",


    //CHAT

    GET_CHAT: 'protected/chat/fetch-my-chat',
    GET_CHAT_PERSON_PRIVATE: 'protected/chat/private',
    // GET_CHAT_PERSON_PRIVATE :'protected/chat/private',
    GET_CHAT_PERSON_GROUP: 'protected/chat/groups',

    PRIVATE_CHAT: 'protected/chat/private',
    GROUP_CHAT: "protected/chat/groups",
    HANDLE_PRIVATE_CHAT:"protected/chat/create-private-chat",
}